import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

export const CardContainer = styled.div`
  display: flex;
  position: relative;
  padding: 16px 80px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-normal);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Interaction = styled.div`
  border-radius: 12px;
  background: var(--alias-color-label-normal);
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:hover {
    opacity: 0.06;
  }
  &:active {
    opacity: 0.09;
  }
`;
